
/*!
 * Chart.js
 * http://chartjs.org/
 *
 * Copyright 2013 Nick Downie
 * Released under the MIT license
 * https://github.com/nnnick/Chart.js/blob/master/LICENSE.md
 *
 *
 ** modifié pour ne garder que le dognut sans animations.
 */

bnpp.Chart = function(t) {
    function n(t, n, a) {
        r(a), n(1);
    }
    function a(t) {
        return Math.min.apply(Math, t);
    }
    function e(t, n) {
        var a = {};
        for (var e in t) a[e] = t[e];
        for (var e in n) a[e] = n[e];
        return a;
    }
    var i = this, o = t.canvas.width, c = t.canvas.height;
    window.devicePixelRatio && (t.canvas.style.width = o + "px", t.canvas.style.height = c + "px", 
    t.canvas.height = c * window.devicePixelRatio, t.canvas.width = o * window.devicePixelRatio, 
    t.scale(window.devicePixelRatio, window.devicePixelRatio)), this.Doughnut = function(n, a) {
        i.Doughnut.defaults = {
            percentageInnerCutout: 87
        };
        var o = a ? e(i.Doughnut.defaults, a) : i.Doughnut.defaults;
        return new u(n, o, t);
    };
    var r = function(t) {
        t.clearRect(0, 0, o, c);
    }, u = function(t, e, i) {
        function r() {
            for (var n = -Math.PI / 2, a = 1, e = 1, r = 0; r < t.length; r++) {
                var v = e * t[r].value / u * 2 * Math.PI;
                i.beginPath(), i.arc(o / 2, c / 2, a * h, n, n + v, !1), i.arc(o / 2, c / 2, a * l, n + v, n, !0), 
                i.closePath(), i.fillStyle = t[r].color, i.fill(), n += v;
            }
        }
        for (var u = 0, h = a([ c / 2, o / 2 ]) - 5, l = h * (e.percentageInnerCutout / 100), v = 0; v < t.length; v++) u += t[v].value;
        n(e, r, i);
    };
};
define("donuts", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.bnpp.Chart;
    };
}(this)));
